import { type FilesViewerProps } from '../FilesViewer';
import useSettings from '../../hooks/useSettings';

/** This component can display pictures */
export default function ImageViewer({ fileEncoded, fileType }: FilesViewerProps) {
	const { t } = useSettings();

	return <img src={`data:image/${fileType};base64,${fileEncoded}`} alt={t('ERROR_IMAGE_NOT_AVAILABLE')} />;
}
